import { FaDiscord } from "react-icons/fa6";

import { Button } from "#/components/ui/button";
import { DISCORD_INVITE_URL } from "#/lib/discordInvite";

export function DiscordInviteButton({ label, className }: { label: string; className?: string }) {
  return (
    <Button
      size="sm"
      variant="discord"
      className={className}
      render={<a href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer" />}
    >
      <FaDiscord data-icon="inline-start" aria-hidden="true" />
      {label}
    </Button>
  );
}
